const COOKIE = 'arctic_analytics_excluded'

export function browserAnalyticsExcluded(): boolean {
    try { return document.cookie.split(';').some(value => value.trim() === `${COOKIE}=1`) } catch { return false }
}

// The admin and booking app share this preference across Arctic Hire subdomains.
// A browser opt-out only suppresses analytics; it confers no access privileges.
export function setBrowserAnalyticsExcluded(excluded: boolean): boolean {
    const hostname = window.location.hostname
    const domain = hostname === 'arctic-hire.co.uk' || hostname.endsWith('.arctic-hire.co.uk') ? '; Domain=arctic-hire.co.uk' : ''
    const secure = window.location.protocol === 'https:' ? '; Secure' : ''
    try {
        document.cookie = `${COOKIE}=${excluded ? '1' : '0'}; Max-Age=${excluded ? 31536000 : 0}; Path=/; SameSite=Lax${domain}${secure}`
        return browserAnalyticsExcluded() === excluded
    } catch { return false }
}
